import { createContext, useState } from "react"

export const AppContext = createContext()

const AppProvider = ({ children }) => {
    const [user, setUser] = useState(null)
    const [message, setMessage] = useState('')

    return (
        <AppContext.Provider value = {{ user, setUser, message, setMessage }}>
            { children }
        </AppContext.Provider>
    )
}

export default AppProvider